import Vue from 'vue'
import confirm from '@/components/confirmation-modal/confirm.vue'
export default Vue.extend({
  name: 'ConfirmEmail',
  components: {
    confirm
  },
  data() {
    return {
      valid: true,
      confirmRegisterForm: {
        token: this.$route.params.token,
        type: 'MEMBER_REGISTRATION'
      },
      title: '既に本登録いただいているか、有効期限が切れています。',
      description: '既に本登録いただいている場合は「パスワードを忘れた方はこちら」からパスワードリセットをお試しください。'
          + '\n\n' + '本登録されていない方は、お手数ですが以下の対応をお願いいたします。' + '\n\n' + '個人でご利用の方：改めて新規ユーザ登録をお願いいたします。'
          + '\n\n' + '法人でご利用の方：ご契約の法人の管理者（PolariStation担当）へご連絡ください。',
    }
  },

  created() {
    this.handleVerifyToken()
  },

  methods: {
    async confirmRegister() {
      await this.$store
          .dispatch('confirmRegister', this.$route.params.token)
          .then(() => {
            this.$router.push({ path: '/register/complete' })
          }).catch(() => {
            this.valid = false
          })
    },

    async handleVerifyToken() {
      await this.$store
          .dispatch('verifyToken', this.confirmRegisterForm)
          .then(() => {
            this.confirmRegister()
          })
          .catch(() => {
            this.valid = false
          })
    }
  }
})
